import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, unref as _unref, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "analysis-panel" };
const _hoisted_2 = {
    key: 0,
    class: "analysis-heading"
};
const _hoisted_3 = {
    key: 1,
    class: "analysis-search"
};
const _hoisted_4 = { class: "analysis-tabs" };
const _hoisted_5 = {
    key: 2,
    class: "analysis-list"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = { class: "category-left" };
const _hoisted_8 = ["src"];
const _hoisted_9 = { class: "category-info" };
const _hoisted_10 = { class: "category-name" };
const _hoisted_11 = { class: "category-count" };
const _hoisted_12 = { class: "category-right" };
const _hoisted_13 = ["src"];
const _hoisted_14 = {
    key: 3,
    class: "analysis-list"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = { class: "category-left" };
const _hoisted_17 = ["src"];
const _hoisted_18 = ["src", "onError"];
const _hoisted_19 = { class: "category-info" };
const _hoisted_20 = { class: "category-name" };
const _hoisted_21 = { class: "category-count" };
const _hoisted_22 = { class: "category-right" };
const _hoisted_23 = ["src"];
import { ref, computed, getCurrentInstance } from 'vue';
import { useAppState } from '@/composables/useAppState';
import { getMerchantLogoUrl, getMerchantLogoStyle, onMerchantLogoError, isWellKnownLogosOnly } from '@/utils/helpers';
import MGTextField from './MGTextField.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CategoryAnalysisList',
    props: {
        categories: {},
        merchants: { default: () => [] },
        showMerchants: { type: Boolean, default: true },
        limit: { default: 5 },
        initialTab: { default: 'analysis' },
        dateRange: {}
    },
    emits: ["category-click", "merchant-click"],
    setup(__props, { emit: __emit }) {
        const state = useAppState();
        const props = __props;
        const emit = __emit;
        const selectedTab = ref(props.initialTab);
        const searchQuery = ref('');
        const expanded = ref(false);
        const filteredCategories = computed(() => {
            const q = searchQuery.value.trim().toLowerCase();
            if (!q)
                return props.categories;
            return props.categories.filter(c => c.name.toLowerCase().includes(q));
        });
        const filteredMerchants = computed(() => {
            const q = searchQuery.value.trim().toLowerCase();
            if (!q)
                return props.merchants;
            return props.merchants.filter(m => m.name.toLowerCase().includes(q));
        });
        const visibleCategories = computed(() => props.limit > 0 && !searchQuery.value && !expanded.value
            ? filteredCategories.value.slice(0, props.limit)
            : filteredCategories.value);
        const visibleMerchants = computed(() => props.limit > 0 && !searchQuery.value && !expanded.value
            ? filteredMerchants.value.slice(0, props.limit)
            : filteredMerchants.value);
        const showCategoriesToggle = computed(() => props.limit > 0 && !searchQuery.value && filteredCategories.value.length > props.limit);
        const showMerchantsToggle = computed(() => props.limit > 0 && !searchQuery.value && filteredMerchants.value.length > props.limit);
        const wellKnownLogosOnlyGlobal = getCurrentInstance()?.appContext.config.globalProperties.$wellKnownLogosOnly;
        function toLogoInput(m) {
            return {
                name: m.name,
                wellKnown: !!m.merchant,
                iconPath: m.iconPath,
                iconColour: m.iconColour,
                wellKnownLogosOnly: isWellKnownLogosOnly(wellKnownLogosOnlyGlobal),
            };
        }
        function isCategoryFallback(m) {
            return isWellKnownLogosOnly(wellKnownLogosOnlyGlobal) && !m.merchant;
        }
        function getMerchantAvatar(m) {
            return getMerchantLogoUrl(toLogoInput(m));
        }
        function getMerchantAvatarStyle(m) {
            return getMerchantLogoStyle(toLogoInput(m));
        }
        function onMerchantAvatarError(e, m) {
            onMerchantLogoError(e, m);
        }
        function getCategoryIcon(iconPath) {
            if (!iconPath)
                return require('@/assets/transactions/home.png');
            try {
                const base = iconPath.toLowerCase().replace('.svg', '');
                return require('@/assets/transactions/' + base + '.png');
            }
            catch (e) {
                return require('@/assets/transactions/home.png');
            }
        }
        function onCategoryIconError(e) {
            e.target.src = require('@/assets/transactions/home.png');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.dateRange)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Analysis for " + _toDisplayString(_ctx.dateRange), 1))
                    : _createCommentVNode("", true),
                (_ctx.limit <= 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(MGTextField, {
                            modelValue: searchQuery.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchQuery).value = $event)),
                            "prepend-inner-icon": "mdi-magnify",
                            density: "compact",
                            label: "Search",
                            variant: "solo",
                            flat: true,
                            "hide-details": "",
                            clearable: "",
                            "single-line": "",
                            "bg-color": "#eeeeee",
                            "onClick:clear": _cache[1] || (_cache[1] = ($event) => (searchQuery.value = ''))
                        }, null, 8, ["modelValue"])
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", {
                        class: _normalizeClass(['tab', { selected: selectedTab.value === 'analysis' }]),
                        onClick: _cache[2] || (_cache[2] = ($event) => (selectedTab.value = 'analysis'))
                    }, " Categories ", 2)
                ]),
                (selectedTab.value === 'analysis')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_TransitionGroup, {
                            name: "row",
                            tag: "div",
                            class: "row-group"
                        }, {
                            default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleCategories.value, (cat) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: cat.name,
                                        class: "category-row",
                                        onClick: ($event) => (emit('category-click', cat.name, cat.colour))
                                    }, [
                                        _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("div", {
                                                class: "category-icon",
                                                style: _normalizeStyle({ backgroundColor: cat.colour })
                                            }, [
                                                _createElementVNode("img", {
                                                    class: "category-icon-img",
                                                    src: getCategoryIcon(cat.iconPath),
                                                    onError: onCategoryIconError,
                                                    alt: ""
                                                }, null, 40, _hoisted_8)
                                            ], 4),
                                            _createElementVNode("div", _hoisted_9, [
                                                _createElementVNode("span", _hoisted_10, _toDisplayString(cat.name), 1),
                                                _createElementVNode("span", _hoisted_11, _toDisplayString(cat.transactionCount) + " transactions", 1)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_12, [
                                            _createElementVNode("span", {
                                                class: _normalizeClass(["category-amount", { moneyIn: cat.isIncome }])
                                            }, _toDisplayString(cat.isIncome ? '+' : '') + _toDisplayString(_unref(state).formatter.format(cat.amount)), 3),
                                            _createElementVNode("img", {
                                                class: "category-arrow",
                                                src: require('@/assets/arrow-right.png'),
                                                alt: ""
                                            }, null, 8, _hoisted_13)
                                        ])
                                    ], 8, _hoisted_6));
                                }), 128))
                            ]),
                            _: 1
                        }),
                        (showCategoriesToggle.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "view-more",
                                onClick: _cache[3] || (_cache[3] = ($event) => (expanded.value = !expanded.value))
                            }, _toDisplayString(expanded.value ? 'View less' : 'View more'), 1))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                (selectedTab.value === 'merchants')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createVNode(_TransitionGroup, {
                            name: "row",
                            tag: "div",
                            class: "row-group"
                        }, {
                            default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleMerchants.value, (merchant) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: merchant.name,
                                        class: "category-row",
                                        onClick: ($event) => (emit('merchant-click', merchant.name))
                                    }, [
                                        _createElementVNode("div", _hoisted_16, [
                                            (isCategoryFallback(merchant))
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    class: "category-icon",
                                                    style: _normalizeStyle({ backgroundColor: merchant.iconColour })
                                                }, [
                                                    _createElementVNode("img", {
                                                        class: "category-icon-img",
                                                        src: getCategoryIcon(merchant.iconPath),
                                                        onError: onCategoryIconError,
                                                        alt: ""
                                                    }, null, 40, _hoisted_17)
                                                ], 4))
                                                : (_openBlock(), _createElementBlock("img", {
                                                    key: 1,
                                                    class: "merchant-avatar",
                                                    src: getMerchantAvatar(merchant),
                                                    style: _normalizeStyle(getMerchantAvatarStyle(merchant)),
                                                    onError: ($event) => (onMerchantAvatarError($event, merchant))
                                                }, null, 44, _hoisted_18)),
                                            _createElementVNode("div", _hoisted_19, [
                                                _createElementVNode("span", _hoisted_20, _toDisplayString(merchant.name), 1),
                                                _createElementVNode("span", _hoisted_21, _toDisplayString(merchant.transactionCount) + " transactions", 1)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_22, [
                                            _createElementVNode("span", {
                                                class: _normalizeClass(["category-amount", { moneyIn: merchant.isIncome }])
                                            }, _toDisplayString(merchant.isIncome ? '+' : '') + _toDisplayString(_unref(state).formatter.format(merchant.amount)), 3),
                                            _createElementVNode("img", {
                                                class: "category-arrow",
                                                src: require('@/assets/arrow-right.png'),
                                                alt: ""
                                            }, null, 8, _hoisted_23)
                                        ])
                                    ], 8, _hoisted_15));
                                }), 128))
                            ]),
                            _: 1
                        }),
                        (showMerchantsToggle.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "view-more",
                                onClick: _cache[4] || (_cache[4] = ($event) => (expanded.value = !expanded.value))
                            }, _toDisplayString(expanded.value ? 'View less' : 'View more'), 1))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
